import { render, staticRenderFns } from "./ConversationParticipants.vue?vue&type=template&id=0fcbed1e"
import script from "./ConversationParticipants.vue?vue&type=script&lang=js"
export * from "./ConversationParticipants.vue?vue&type=script&lang=js"
import style0 from "./ConversationParticipants.vue?vue&type=style&index=0&id=0fcbed1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports